import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { Link } from 'react-router-dom';
import logo from '../../../Assets/logo/skilletix.png';
import ComplaintSubmitModal from "./ComplaintSubmitModal";
import ComplaintErrorModal from "./ComplaintErrorModal";



const Complaint = () => {
  const [userDetails, setUserDetails] = useState(null);
  // const [success, setSuccess] = useState(false);
 // NEW: State for controlling modals
 const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false); // Controls the success modal
 const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);   // Controls the error modal
 const [errorMessage, setErrorMessage] = useState("");              // Holds error message for the error modal
  const initialValues = {
    name: '',
    email: '',
    mobile: '',
    subject: '',
    message: ''
  };

  const fetchUserDetails = async () => {
    const userId = localStorage.getItem('userid');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}users/searchuser/${userId}`
      );
      const { email, mobile, name } = response.data[0];
      setUserDetails({
        name: name,
        email: email,
        mobile: mobile,
        subject: '',
        message: ''
      });
    } catch (error) {
      console.error(error);
      setUserDetails(null);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const handleSubmitComplaint = async (values, { resetForm }) => {
    try {
      const userId = localStorage.getItem('userid') || Math.floor(Math.random() * 1000000000);
      await axios.post(`${process.env.REACT_APP_API_URL}complaints/createcomplaint`, { ...values, user_id: userId });
      // alert('Complaint submitted successfully');
      setIsSubmitModalOpen(true);
      resetForm();
    } catch (error) {
      console.error('Error submitting complaint:', error);
      // alert('Failed to submit complaint. Please try again.');
      setErrorMessage('Failed to submit complaint. Please try again.');
      setIsErrorModalOpen(true);
    }
  };
  
  return (
    <div 
      className="login-area py-120" 
      style={{
        backgroundColor: '#f9fafb', 
        minHeight: '100vh', 
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <div className="container">
        <div className="col-md-10 col-lg-9 col-xl-7 mx-auto">
          {/* Card-like container for the form */}
          <div 
            className="login-form p-4 p-sm-5"
            style={{
              backgroundColor: '#f2f6fd',  // UPDATED COLOR
              borderRadius: '8px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          >
            {/* Header */}
            <div className="login-header text-center mb-4">
              <img
              loading="lazy"
              role="presentation"
              decoding="async"
              fetchpriority="high" 
                src={logo} 
                alt="Logo" 
                style={{ maxWidth: '180px', marginBottom: '10px' }}
              />
              <h4 style={{ fontWeight: '600', marginTop: '10px' }}>
                Create Complaint
              </h4>
            </div>

            {/* Formik Form */}
            <Formik
              initialValues={userDetails || initialValues}
              enableReinitialize={true}
              validate={(values) => {
                const errors = {};
                if (!values.subject) errors.subject = 'Subject is required';
                if (!values.message) errors.message = 'Message is required';
                if (!values.mobile) errors.mobile = 'Mobile is required';
                if (!values.name) errors.name = 'Name is required';
                if (!values.email) errors.email = 'Email is required';
                return errors;
              }}
              onSubmit={handleSubmitComplaint}
            >
              {() => (
                <Form>
                  <div className="form-group mb-3">
                    <label 
                      htmlFor="name" 
                      style={{ fontWeight: '500' }}
                    >
                      Name
                    </label>
                    <Field
                      type="text"
                      name="name"
                      placeholder="Enter your name"
                      className="form-control"
                      disabled={userDetails !== null}
                      style={
                        userDetails 
                          ? { backgroundColor: '#f8f9fa', cursor: 'not-allowed' }
                          : {}
                      }
                    />
                    <ErrorMessage 
                      name="name" 
                      component="div" 
                      className="text-danger mt-1" 
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label 
                      htmlFor="mobile" 
                      style={{ fontWeight: '500' }}
                    >
                      Mobile
                    </label>
                    <Field
                      type="text"
                      name="mobile"
                      placeholder="Enter your mobile number"
                      className="form-control"
                      disabled={userDetails !== null}
                      style={
                        userDetails 
                          ? { backgroundColor: '#f8f9fa', cursor: 'not-allowed' }
                          : {}
                      }
                    />
                    <ErrorMessage 
                      name="mobile" 
                      component="div" 
                      className="text-danger mt-1" 
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label 
                      htmlFor="email" 
                      style={{ fontWeight: '500' }}
                    >
                      Email
                    </label>
                    <Field
                      type="email"
                      name="email"
                      placeholder="Enter your email address"
                      className="form-control"
                      disabled={userDetails !== null}
                      style={
                        userDetails 
                          ? { backgroundColor: '#f8f9fa', cursor: 'not-allowed' }
                          : {}
                      }
                    />
                    <ErrorMessage 
                      name="email" 
                      component="div" 
                      className="text-danger mt-1" 
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label 
                      htmlFor="subject" 
                      style={{ fontWeight: '500' }}
                    >
                      Subject
                    </label>
                    <Field
                      type="text"
                      name="subject"
                      placeholder="Complaint subject"
                      className="form-control"
                    />
                    <ErrorMessage 
                      name="subject" 
                      component="div" 
                      className="text-danger mt-1" 
                    />
                  </div>

                  <div className="form-group mb-4">
                    <label 
                      htmlFor="message" 
                      style={{ fontWeight: '500' }}
                    >
                      Message
                    </label>
                    <Field
                      as="textarea"
                      name="message"
                      placeholder="Explain your complaint here"
                      className="form-control"
                      rows="4"
                    />
                    <ErrorMessage 
                      name="message" 
                      component="div" 
                      className="text-danger mt-1" 
                    />
                  </div>

                  <div className="d-flex align-items-center justify-content-center">
                  <style>
        {`
          /* Force override the hover state */
          .theme-btn.btn.btn-primary:hover {
            background-color: #0b5ed7 !important;
            background-image: none !important;
            background-size: auto !important;
          }
        `}
      </style>
                    <button 
                      type="submit" 
                      className="theme-btn btn btn-primary"
                      style={{
                        display: 'inline-block',
                        width: '100%',   
                        padding: '0.6rem 1.5rem',
                        borderRadius: '4px',
                        fontWeight: '500',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      Submit Complaint
                    </button>
                  </div>
                </Form>
              )}
            </Formik>

            {/* Success Alert */}
            {/* {success && (
              <div className="alert alert-success mt-4 text-center">
                Complaint submitted successfully.
              </div>
            )} */}

            {/* You could optionally add a "Back" link here if desired */}
            <div className="text-center mt-3">
              <Link to="/" style={{ textDecoration: 'none' }}>
                &larr; Go back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* NEW: Render the Complaint Submission Success Modal */}
      <ComplaintSubmitModal 
        isOpen={isSubmitModalOpen} 
        setIsOpen={setIsSubmitModalOpen} 
      />

      {/* NEW: Render the Complaint Error Modal */}
      <ComplaintErrorModal 
        isOpen={isErrorModalOpen} 
        setIsOpen={setIsErrorModalOpen} 
        errorMessage={errorMessage} 
      />
    </div>
  );
};

export default Complaint;
